import React from 'react'
import PropTypes from 'prop-types'
// import Weather from "ui/schedule/Weather";

function ShiftHeader ({ date, title, weather, progressBar }) {
  const dateEl = date ? <div className='text-gray-400 text-xs flex items-center'>{date}</div> : null
  const titleEl = title ? <div className='text-gray-900 text-base font-medium mt-1 capitalize'>{title}</div> : null

  return (
    <div className='border border-transparent mb-6 cursor-pointer'>
      <div className='relative'>
        <div className='relative'>
          {dateEl}
          {titleEl}
          {weather}
        </div>
        <div style={{paddingTop: 40}}>
        {progressBar}
        </div>
      </div>
    </div>
  )
}

ShiftHeader.defaultProps = {
}

ShiftHeader.propTypes = {
  /**
     * Date to be displayed on the card
     */
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * String for the title/day
     */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * String for the subtitle (displayed below the title)
     */
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
     * Weather component
     */
  weather: PropTypes.node,
  /**
     * Image link
     */
  href: PropTypes.string,
  /**
     * Image src
     */
  src: PropTypes.string,
  /**
     * Add a progress bar to the header
     */
  progressBar: PropTypes.node
}

export default ShiftHeader
